module.exports = "<ng-include src=\"'./common/templates/_nav.jade'\"></ng-include><div class=\"animate-wrapper\" resize=\"height\" resize-dependence=\".header_home\" resize-margin=\"1\" resize-attr=\"min-height\"><ui-view class=\"animate\"></ui-view></div><ng-include src=\"'./common/templates/_footer.jade'\"></ng-include>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/common/templates/public-layout.jade
// module id = 291
// module chunks = 0